// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__kY9dI","title":"BackImages_title__1q_09","images":"BackImages_images__XZq3-"};